// Utility function to deduplicate conversation messages
export const deduplicateMessages = (messages) => {
  if (!messages || !Array.isArray(messages)) {
    return messages;
  }

  console.log(`[Deduplication] Starting deduplication for ${messages.length} messages`);
  const deduplicatedMessages = [];
  const seenMessages = new Map();
  
  messages.forEach((message) => {
    const content = message.content?.trim() || '';
    const timestamp = new Date(message.createdAt).getTime();
    
    // Create a key for duplicate detection
    const messageKey = `${message.role}:${content}`;
    
    // Check if we've seen this exact message before
    if (seenMessages.has(messageKey)) {
      const existingEntries = seenMessages.get(messageKey);
      
      // Check against all existing entries with same key
      let isDuplicate = false;
      for (const existingTimestamp of existingEntries) {
        const timeDiff = Math.abs(timestamp - existingTimestamp);
        
        // If messages are within 60 seconds of each other, consider it a duplicate
        if (timeDiff < 60000) {
          console.log(`[Deduplication] Found duplicate message:`, {
            role: message.role,
            content: content.substring(0, 50) + '...',
            timeDiff: timeDiff
          });
          isDuplicate = true;
          break;
        }
      }
      
      if (!isDuplicate) {
        deduplicatedMessages.push(message);
        existingEntries.push(timestamp);
      }
    } else {
      // First occurrence of this message
      deduplicatedMessages.push(message);
      seenMessages.set(messageKey, [timestamp]);
    }
  });
  
  console.log(`[Deduplication] Reduced from ${messages.length} to ${deduplicatedMessages.length} messages`);
  return deduplicatedMessages;
};